import { Environment } from 'config';
import request from 'utils/request';
import * as Types from '../types';

/** fetchPointOfInterestCategoryList  */
export interface IPointOfInterestCategoryListOutput {
  items: IDataItems[];
  paging: IPaging;
}

export interface IDataItems {
  id: number;
  name: string | null;
  icon: string | null;
  color: string | null;
  pictureid: number;
  storeid: number;
  datecreated: string | null;
}

interface IPaging {
  page: string;
  pageSize: string;
  total: number;
}

export interface IPointOfInterestCategoryListInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
}

export const fetchPointOfInterestCategoryList = async (
  payload: IPointOfInterestCategoryListInput
): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/pointofinterestcategory/list?page=${payload.page}&pageSize=${payload.pageSize}&sortField=${payload.sortField}&order=${payload.order}`
  );

  let _data: IPointOfInterestCategoryListOutput = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

/** PointOfInterestCategory Detail */
interface IPointOfInterestCategoryDetailInput {
  id: number;
}

interface IPointOfInterestCategoryDetailOutput extends Types.ResponseOutput {
  data: {
    id: number | null;
    name: string | null;
    icon: string | null;
    color: string | null;
    pictureid: number | null;
    storeid: number | null;
    datecreated: string | null;
  };
}

export const fetchPointOfInterestCategoryDetail = async (
  payload: IPointOfInterestCategoryDetailInput
): Promise<IPointOfInterestCategoryDetailOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/pointofinterestcategory/${payload.id}`
  );

  let output = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};

/** Add PointOfInterestCategory */
export interface IPointOfInterestCategoryAddInput {
  name: string | null;
  icon: string | null;
  color: string | null;
  pictureid?: number | null;
  picture?: any;
}

interface IPointOfInterestCategoryAddOutput extends Types.ResponseOutput {
  data: {};
}

export const addPointOfInterestCategory = async (
  payload: IPointOfInterestCategoryAddInput
): Promise<IPointOfInterestCategoryAddOutput> => {
  const { data }: any = await request(
    'post',
    `${Environment.API_BASE_URL}/api/pointofinterestcategory `,
    { body: payload }
  );

  let output = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};

/** Edit PointOfInterestCategory */
export interface IPointOfInterestCategoryEditInput {
  id?: number;
  name: string | null;
  icon: string | null;
  color: string | null;
  pictureid?: number | null;
  picture?: any;
}

interface IPointOfInterestCategoryEditOutput extends Types.ResponseOutput {
  data: {};
}

export const editPointOfInterestCategory = async (
  payload: IPointOfInterestCategoryEditInput
): Promise<IPointOfInterestCategoryEditOutput> => {
  const { id, ...rest } = payload;
  const { data }: any = await request(
    'patch',
    `${Environment.API_BASE_URL}/api/pointofinterestcategory/${id}`,
    { body: rest }
  );

  let output = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};

interface IPointofInterestDeleteOutput extends Types.ResponseOutput {
  data: {};
}

export const deletePointofInterestCategory = async (
  id: number
): Promise<IPointofInterestDeleteOutput> => {
  const { data }: any = await request(
    'delete',
    `${Environment.API_BASE_URL}/api/pointofinterestcategory/${id}`
  );

  let output = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};
